import { Attachment } from 'models/attachments.model'
import api from '../..'

const ProgressReportExport = () => {
  return api.get<string | Attachment>(
    'administration/courses/progress_report_export'
  )
}

export default ProgressReportExport
